$ ->
  $('.policy-form a').click (e) ->
    e.preventDefault()
    $(this).siblings('.form').slideToggle()
